import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Buildings from "../views/Buildings.vue";
import Templates from "../views/Templates.vue";
import Technicians from "../views/Technicians.vue";
import Prolendar from "../views/Prolendar.vue";

Vue.use(VueRouter);

const routes = [{
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/buildings",
    name: "buildings",
    component: Buildings
  },
  {
    path: "/templates",
    name: "templates",
    component: Templates
  },
  {
    path: "/technicians",
    name: "technicians",
    component: Technicians
  },
  {
    path: "/prolendar",
    name: "prolendar",
    component: Prolendar
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;